import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.57574 8.07574L3.02426 5.52426C2.64629 5.14629 2.91399 4.5 3.44853 4.5H8.55147C9.08601 4.5 9.35372 5.14628 8.97574 5.52426L6.42426 8.07574C6.18995 8.31005 5.81005 8.31005 5.57574 8.07574Z",
		fill: "currentColor"
	})
});
export default SvgCaretDown;
